module.exports = `${require.publicPath}footer-img01.bdfff775.png`;